import React, {useEffect} from "react";
import {Skeleton, Dialog, DialogTitle, DialogContent, IconButton, Typography,  ListItem, ListItemText} from "@mui/material";
import CloseIcon from "../../../assets/icons/close.png";
import moment from "moment";
import useAnalytics from "../../../hooks/useAnalytics";

const ProductViewDetailsDialog = (props) => {

    const {openProductView, setOpenProductView, verificationData} = props;
   
    const {isFetchingProductView, productViewDetails, getTopProductAuthenticationDetailView} = useAnalytics();

    const handleCloseDialog = () => {
        setOpenProductView(false);
    }

    useEffect(() => {
        if (verificationData) {
            getTopProductAuthenticationDetailView(verificationData?.product_code);
        }
    }, [verificationData])


    return (
        <Dialog open={openProductView} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{style: {borderRadius: "8px", padding: " 20px 24px"}, elevation: 24}}>
            <DialogTitle sx={{display: "flex"}}>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={{position: 'absolute', right: 36, top: 24}}
                >
                    <img alt="close-icon" src={CloseIcon} style={{height: 22}} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{padding: "20px 8px"}}>
                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Product Code:
                            </Typography>
                        } 
                        secondary={(isFetchingProductView) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, fontWeight: 500, ml: 1}}>
                                {productViewDetails?.product_code}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Product Name:
                             </Typography>
                        } 
                        secondary={(isFetchingProductView) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {productViewDetails?.product_name}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Description:  
                             </Typography>
                        } 
                        secondary={(isFetchingProductView) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {productViewDetails?.description}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Verification Count:  
                             </Typography>
                        } 
                        secondary={(isFetchingProductView) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {verificationData?.verificationCount}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                               Authentication Count:
                             </Typography>
                        } 
                        secondary={(isFetchingProductView) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {verificationData?.authenticationCount}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Timestamp:   
                             </Typography>
                        } 
                        secondary={(isFetchingProductView) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {moment(productViewDetails?.updated_time).format('YYYY-MM-DD hh:mm:ss A')}
                            </Typography>
                        }
                    />
                </ListItem>
            </DialogContent>
        </Dialog>
    )
}

export default ProductViewDetailsDialog

